import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const ApprovedApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Approved Applications(SLAC)"
        status={[applicationStatusMap?.approved.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default ApprovedApplications;
